import React from 'react';
import { Paper, Typography } from '@mui/material';

const StatTile = ({ label, value, gradient }) => (
  <Paper
    elevation={4}
    sx={{
      p: 2,
      height: { xs: 100, sm: 110, md: 120 },
      width: { xs: 130, sm: 260, md: 340 },
      background: gradient,
      borderRadius: 3,
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Typography variant="h6" fontWeight="bold" fontSize={{ xs: '1.2rem', md: '1.5rem' }}>
      {value}
    </Typography>
    <Typography variant="subtitle2" fontSize={{ xs: '0.75rem', md: '0.875rem' }}>
      {label}
    </Typography>
  </Paper>
);

export default StatTile;

